"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectedBreadcrumbs = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const context_1 = require("../../context");
const useBehaviorSubject_1 = require("../../hooks/useBehaviorSubject");
const PageBreadcrumbs_1 = require("./PageBreadcrumbs");
const ConnectedBreadcrumbs = () => {
    const services = (0, context_1.useUiServices)();
    const steps = (0, useBehaviorSubject_1.useBehaviorSubject)(services.nav.steps$);
    const page = services.content.root;
    return React.createElement(PageBreadcrumbs_1.PageBreadcrumbs, { page: page, steps: steps });
};
exports.ConnectedBreadcrumbs = ConnectedBreadcrumbs;
